module.exports = require("./fr-MF.d.ts");